import { render, staticRenderFns } from "./CAxASCxSocialPt6Page.vue?vue&type=template&id=04334299"
import script from "./CAxASCxSocialPt6Page.vue?vue&type=script&lang=js"
export * from "./CAxASCxSocialPt6Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports